module.exports = __webpack_public_path__ + "static/media/benefit_3.16ff6d35.JPG";